import styles from './FJUsageDetail.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJArrowIcon from '../../../../assets/svg/detail-arrow.svg?react';
import FJDropdownNew from '../../../components/FJDropDown/FJDropdownNew.jsx';
import cionNewUrl from '../../../../assets/base64/cion-new.js';
import FJConfig from '../../../../config/FJConfig.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';

const FJUsageDetail = props => {
    const { currentQuality, currentDuration } = props;
    const creditOfQuality = currentQuality === 1 ? 2 : 7;

    const totalCredit = () => {
        switch (FJConfig.appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR:
                return creditOfQuality * currentDuration;
            case FJAppConstant.AI_AUDIO_GENERATOR:
                return 10;
            default:
        }
    };

    const getTitle1 = () => {
        switch (FJConfig.appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR:
                return FJLocalStore._(currentQuality === 1 ? 'standard' : 'professional');
            case FJAppConstant.AI_AUDIO_GENERATOR:
                return FJLocalStore._('ai-music-generator');
            default:
        }
    };

    const getAnswer1 = () => {
        switch (FJConfig.appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR:
                return (
                    <>
                        {creditOfQuality}
                        &nbsp;
                        {FJLocalStore._('credits-s')}
                    </>
                );
            case FJAppConstant.AI_AUDIO_GENERATOR:
                return (
                    <>
                        10 &nbsp;
                        {FJLocalStore._('credits-time')}
                    </>
                );
            default:
        }
    };

    const getTitle2 = () => {
        switch (FJConfig.appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR:
                return FJLocalStore._('duration');
            case FJAppConstant.AI_AUDIO_GENERATOR:
                return FJLocalStore._('current-consumption');
            default:
        }
    };

    const getAnswer2 = () => {
        switch (FJConfig.appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR:
                return <>{currentDuration}s</>;
            case FJAppConstant.AI_AUDIO_GENERATOR:
                return FJLocalStore._('1-time');
            default:
        }
    };

    const _renderTrigger = config => {
        return (
            <div className={styles.box} onMouseMove={config.onMouseMove} ref={config.ref}>
                <div className={styles.detail}>{FJLocalStore._('usage-details')}</div>
                <FJArrowIcon />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.detail_box} ref={config.ref}>
                <div className={styles.title}>{FJLocalStore._('usage-details')}</div>
                <ul className={styles.usage_item}>
                    <li>
                        <div className={styles.label}>{getTitle1()}</div>
                        <div className={styles.value}>{getAnswer1()}</div>
                    </li>
                    <li>
                        <div className={styles.label}>{getTitle2()}</div>
                        <div className={styles.value}>{getAnswer2()}</div>
                    </li>
                </ul>

                <div className={styles.footer}>
                    <div className={styles.normal_text}>{FJLocalStore._('total')}</div>
                    <div className={styles.credit}>
                        <img src={cionNewUrl} alt='' />
                        <div className={styles.normal_text}>
                            {totalCredit()}
                            &nbsp;
                            {FJLocalStore._(totalCredit() === 1 ? 'credit' : 'credits')}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <FJDropdownNew
            isTopLayer={true}
            renderTrigger={_renderTrigger}
            useAnchorBody
            placement='rightCenter'
            triggerDisplay='flex'
            trigger='hover'
            renderOverlay={_renderOverlay}
        />
    );
};

export default FJUsageDetail;
